import { createCsv } from 'src/app/common/components/reactive-form-builder/export/createCsv';
import { FormType } from 'src/app/common/components/reactive-form-builder/interfaces/form.interface';
import {TareasApiService} from '../../../../service/api/tareas-api.service';
import { Component } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Router} from '@angular/router';
import {DashboardService} from '../../../../service/events/dashboard.service';
import {RequestHandler} from '../../../../service/OffService/request-handler';
import {BaseView} from '../../../base-view';
import moment, { Moment } from 'moment';
import { environment } from 'src/environments/environment';
import { Filtering } from 'src/app/service/filtering/filtering';
import {StorageManager} from '../../../../common/storage-manager.class';
const TRUTHY_VALUES = [1, '1', true, 'true'];

import type { OnInit, AfterViewInit } from '@angular/core';
import { TareaPiscinasModel } from 'src/app/models/tareas/tarea-piscinas.model';
import { ColInterface } from 'src/app/common/components/common-list-table/col.interface';
import { ColStylesInterface } from 'src/app/common/components/common-list-table/col-styles.interface';
import { TreeNode } from 'primeng/api';
import { TareasMtoPiscinasFormDefinition } from './tareas-mto-piscinas-form/form-control/form-definition';
@Component({
    selector: 'app-tareas-mto-piscinas',
    standalone: false,
    templateUrl: './tareas-mto-piscinas.component.html',
    styleUrls: ['./tareas-mto-piscinas.component.scss']
})
export class TareasMtoPiscinasComponent extends BaseView<TareaPiscinasModel> implements OnInit, AfterViewInit {

    public rolUser = StorageManager.getUser().rol;
    public hiddenButtonDelete = false;

    public appName = environment.appName;
    public serverUrl = environment.serverUrl;
    public fincaName = environment.features.fincaName; 
    public hasClients = environment.features.hasClients;
    public userCanSeeClientes = this.hasClients &&
  (environment.features.userCanSeeClientes ? true : (StorageManager.getUser().rol === 'admin'));     

    public getRequest: RequestHandler<TareaPiscinasModel[]> = this.tareasApi.mtoPiscinas.GET;
    public deleteRequest: RequestHandler<TareaPiscinasModel> = this.tareasApi.mtoPiscinas.DELETE;
    public pathToForm = 'crear-piscina';  
    public menuItemId = 'piscinas';  

    public override filtering: Filtering<TareaPiscinasModel> = new Filtering<TareaPiscinasModel>();
public override canShow: Record<string, boolean> = {};
    public override model: TareaPiscinasModel = {};

    public form: TareasMtoPiscinasFormDefinition | null = null;
    public cols: ColInterface[] = [
        {field: 'cliente_nombre', header: 'Cliente', filter: ''},
        {field: 'trabajadores_nombres', header: 'Empleado', filter: ''},
        {field: 'finca', header: this.fincaName, filter: ''},
        {field: 'fecha', header: 'Fecha', filter: ''},
        {field: 'hora_inicio', header: 'Hora Inicio', filter: ''},
        {field: 'hora_fin', header: 'Hora Fin', filter: ''},
        {field: 'horas_totales', header: 'Horas', filter: ''},
        {field: 'prioridad', header: 'Prioridad/Realizada', filter: ''},
        {field: 'observaciones', header: 'Observaciones', filter: ''}
    ];  

    optionsSelectButton = [
        { label: 'Todos', value: 0 },
        { label: 'Si', value: 1 },
        { label: 'No', value: 2 }
    ];
    
    public readonly realizadoControl = new FormControl<number>(0, { nonNullable: true });
    selectedYears = 0;

    public totalHoras: Moment | string = '00:00';
    public auxTotalHoras: Moment | string = '00:00';
    public fecha: {inicio: string; fin: string} = {
        inicio: '',
        fin: '',
    };

    constructor(public tareasApi: TareasApiService,
        private dashboard: DashboardService,
        private router: Router) {
        super(dashboard, tareasApi.mtoPiscinas.GET, tareasApi.mtoPiscinas.DELETE);
  
  
    }

    ngOnInit() {
    
        if (environment.features.showTareasMto){
            if (this.rolUser !== 'admin'){
                this.hiddenButtonDelete = true;
            }
            this.realizadoControl.setValue(2);
        }

        this.dashboard.setSubmenuItem('tareas', this.menuItemId);
        this.filtering.addFilter((copy: TreeNode<TareaPiscinasModel>[] | void) => (copy as TreeNode<TareaPiscinasModel>[]).filter(row => {
            const tareaPiscina = row as TareaPiscinasModel;

            switch (this.realizadoControl.value) {
            case 1:
                return ['Realizada'].includes(tareaPiscina.prioridad ?? '');
            case 2:
                return !['Realizada'].includes(tareaPiscina.prioridad ?? '');
            default:
                return true;
            }
        }));
        /*** 
   *  En el caso de que el usuario no se admin,
   * filtrará por su id de usuario que coincide,
   *  con el id trabajador   
  */
        if ( StorageManager.getUser().rol !== 'admin' ){ 
            this.filtering.addFilter((copy: TreeNode<TareaPiscinasModel>[] | void) => 
                (copy as TreeNode<TareaPiscinasModel>[]).filter(row => {
                    const tareaPiscina = row as TareaPiscinasModel;

                    if (tareaPiscina.ids_trabajadores != null ) {
            
                        const idTrabajador = StorageManager.getUser().id;
                        const listaTrabajadores = (tareaPiscina.ids_trabajadores as string).split(';');
                        if ( listaTrabajadores.find( id => id === idTrabajador?.toString() ) ) {
                            return true;
                        }
            
                    }
                    return false;
                }));
        }
  
        /*** 
     *  Fin de filtrar por id_usuario = trabajador,
     *   
    */
        this.filtering.addFilter((copy: TreeNode<TareaPiscinasModel>[] | void) => 
            (copy as TreeNode<TareaPiscinasModel>[]).filter((row: TreeNode<TareaPiscinasModel>) => {
                const tareaPiscina = row as TareaPiscinasModel;

                if (this.fecha.inicio && this.fecha.fin) {
  
                    const arrayFecha = tareaPiscina.fecha?.toString().split('/') ?? '';
                    const fechaAux = arrayFecha[2] + '-' + arrayFecha[1] + '-' + arrayFecha[0];
  
                    if (
                        (moment(moment(this.fecha.inicio).format('YYYY-MM-DD')).diff(fechaAux) <= 0) && 
                    (moment(moment(this.fecha.fin).format('YYYY-MM-DD')).diff(fechaAux) >= 0)) {
                        return true;
                    } else {
                        return false;
                    }
                } else {
                    return true;
                }
            }));
    }

    public add() {
        if (!StorageManager.getClient() && this.userCanSeeClientes) {
            this.dashboard.openClientDialog();
        } else {
            this.router.navigate(['dashboard', this.pathToForm]);
        }
    }
  
    public edit(data: TareaPiscinasModel) {
        //console.log('data',data);
      
        this.router.navigate(['dashboard', 'editar-piscina', data.id]);
    }
  
    public duplicate(data: TareaPiscinasModel) {
        this.router.navigate(['dashboard', 'duplicar-piscina', data.id]);
    }  

    public override deleteRegister() {
        if (this.model.id) {
            this.deleteRequest.safePerform(this.model);
            this.deleteRequest.response(() => {
                if (!this.deleteRequest.hasError) {
                    this.getRequest.safePerform();
                }
            });
        } else {
            this.deleteRequest.hasError = true;
            throw new Error('Trying to DELETE a register without primary key');
        }
    }  
    public override show(modal: string, data: TareaPiscinasModel): void {
        const modalData = { ...data } as TareaPiscinasModel;
        this.coerceSwitchFields(modalData);
        super.show(modal, modalData);

        const formType = modal === 'delete' ? +FormType.DELETION : +FormType.INFORMATIVE;
        this.form = new TareasMtoPiscinasFormDefinition(formType, modalData);
    }

    public override hide(modal: string) {
        this.model = {};
        this.form = null;
        this.canShow[modal] = false;
        this.deleteRequest.reset();
    }

    private coerceSwitchFields(data: TareaPiscinasModel): void {
        const switchFields = [
            'mantenimiento',
            'barredera',
            'cepillado',
            'limpieza_red',
            'rascado_linea_flotacion',
            'lavado_enjuague_cesti',
            'limpieza_duchas',
            'limpieza_skimmer',
            'nivel_vaso',
            'limpieza_cuarto_depuradora',
        ];

        for (const fieldName of switchFields) {
            data[fieldName] = TRUTHY_VALUES.includes(data[fieldName]?.toString() ?? '');
        }
    }

    public globalConditionalStyle(value: string, col: ColInterface): ColStylesInterface {
        if (col.field === 'prioridad') {
            if (value === 'Alta') {
                return {
                    textAlign: 'center',
                    rowStyle: {
                        backgroundColor: '#f44242'
                    },  
                };
            }
            else if (value === 'Realizada'){
                return {
                    textAlign: 'center',
                    rowStyle: {
                        backgroundColor: '#00ff00'
                    },  
                };
            }
        }

        if (col.field === 'trabajadores_nombres') {
            return {
                textAlign: 'center',
                style: {
                    'max-width': '50px',
                }
            };
        }
        if (col.field === 'observaciones') {
            return {
                textAlign: 'center',
                style: {
                    'max-width': '50px',
                }
            };
        }
        return {textAlign: 'center'};
    }
  
    public globalVisualTransform(value: string, col: ColInterface) {
        if (col.field === 'mantenimiento') {
            if ( TRUTHY_VALUES.includes(value) ) {
                return 'Creación';
            } else {
                return 'Mantemiento';
            }
        }
        return value;
    }
  
    public formatDate(date: string) {
        moment.locale('es');
        return moment(date, 'DD/MM/YYYY').format('LL');
    }

    getObservaciones( event: string ) {
        this.model.observaciones = event;
    }

    filtrar(): void {
        this.filtering.filter();
        this.updateFooter();
    }
    public downloadCsv(): void {
        this.form = new TareasMtoPiscinasFormDefinition(+FormType.EXPORT, {});
        const csvContent = createCsv(this.form.fieldNames, this.form.fieldLabels, this.filtering.value as TareaPiscinasModel[]);
        const csvLink = document.getElementById('csvLink') as HTMLAnchorElement | null;

        if (csvLink) {
            csvLink.download = 'Piscinas.csv';
            csvLink.href = encodeURI(csvContent);
            csvLink.click();
        }
    }

    public override updateFooter() {
        this.sum();
    }

    public override sum() {
        this.totalHoras = moment(new Date('October 1, 2014 00:00:00'));
        this.auxTotalHoras = moment(new Date('October 1, 2014 00:00:00'));
        let contador = 0;
        
        (this.filtering.value || []).forEach((tareas, index ) => {
            const horasTotales = (tareas as TareaPiscinasModel).horas_totales;

            if ( horasTotales != null ) {
   
                if (horasTotales.length > 0) {
                    contador++;
                    const horaMinuto = horasTotales.split(':');

                    this.totalHoras = moment(this.totalHoras).add(horaMinuto[0], 'hours').add(horaMinuto[1], 'minutes');
                }
            }

            if ( index + 1 >= (this.filtering.value as TareaPiscinasModel[]).length ){
  
                let minutos = moment(this.totalHoras).format('mm');
      
      
                let differencia = moment(this.totalHoras).diff(this.auxTotalHoras);
      
                if ( minutos.toString().length === 0) {
                    minutos = '00';
                }

                if ( minutos.toString().length === 1) {
                    minutos = '0' + minutos.toString();
                }
                differencia = differencia / (1000 * 60 * 60);
                differencia = Math.abs(Math.floor(differencia));

                this.totalHoras = differencia + ':' + minutos;
      
                if ( contador === 0){
                    this.totalHoras = '00:00';
                }

            }
  
    
        });

        if ( contador === 0){
            this.totalHoras = '00:00';
        }
        this.filtering.filter();
    }

    getFechaInicio(event: string | Date) {
        this.fecha.inicio = this.getFilterDate(event);
        this.filtering.filter();
        this.updateFooter();
  
    }
    getFechaFin(event: string | Date) {
        this.fecha.fin = this.getFilterDate(event);
        this.filtering.filter();
        this.updateFooter();
    }

    private getFilterDate(event: string | Date): string {
        const date = event instanceof Date ? moment(event) : moment(event, ['DD/MM/YYYY', 'YYYY-MM-DD'], true);

        return date.isValid() ? date.format('YYYY-MM-DD') : '';
    }

    ngAfterViewInit() {
        this.tareasApi.mtoPiscinas.GET.response(() => {
            this.updateFooter();
            this.sum();
        });
    }

}
